import React, { lazy, Suspense } from 'react';
import Loading from '../../../../../Loading';

const Tables = lazy(() => import('./Tables'));

const Table = (props) => (
  <Suspense fallback={<Loading />}>
    <Tables {...props} />
  </Suspense>
);

export default Table;
